/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import styles from './MealEntry.module.scss';
import { Row, Col } from 'react-bootstrap';
import TextInput from '../TextInput/TextInput';

export type MealEntryProps = {
  entryNumber: string;
  mealData: any;
  isDisabled?: boolean;
  day: string;
  setIsFormValid?: any;
  isSubmitting?: boolean;
  mealEntryData?: any;
  isEditEntry?: boolean;
  submitEntry?: boolean;
  entryIndex?: Number;
  date?: any;
  checkWorkedDate?: any;
  setSelectedFieldName?: any;
  isDateWorkedEmpty?: boolean;
  selectedFieldName?: string;
};

const MealEntry = ({
  entryNumber,
  mealData,
  day,
  isDisabled = false,
  setIsFormValid,
  mealEntryData,
  isEditEntry,
  submitEntry,
  entryIndex,
  checkWorkedDate,
  setSelectedFieldName,
  isDateWorkedEmpty,
  selectedFieldName,
}: MealEntryProps) => {

  const [breakStart, setBreakStart] = useState('');
  const [breakEnd, setBreakEnd] = useState('');
  const [breakDuration, setBreakDuration] = useState('');

  useEffect(() => {
    if (breakEnd) {
      const convertStartBreak = breakStart ? breakStart.replace(':', '.') : ''
      const convertEndBreak = breakEnd ? breakEnd.replace(':', '.') : ''
      const difference = (parseFloat(convertEndBreak) - parseFloat(convertStartBreak)).toFixed(2)
      var durationParts = difference.toString().split(".");
      const durationInMinutes = Number(durationParts[0]) * 60 + Number(durationParts[1]);
      setBreakDuration(durationInMinutes.toString())
    } else {
      setBreakDuration('')
    }
  }, [breakEnd])

  useEffect(() => {
    if (isEditEntry && mealEntryData.breakStart && mealEntryData.breakEnd) {

      setBreakStart(mealEntryData.breakStart)
      setBreakEnd(mealEntryData.breakEnd)
      setBreakDuration(mealEntryData.breakDuration)
    }
  }, [entryIndex, mealEntryData.breakStart, mealEntryData.breakEnd])

  useEffect(() => {
    mealData({
      [day.toLowerCase() + entryNumber + 'BreakStart']: breakStart,
      [day.toLowerCase() + entryNumber + 'BreakEnd']: breakEnd,
      [day.toLowerCase() + entryNumber + 'BreakDuration']: breakDuration,
    });
    // eslint-disable-next-line
  }, [breakStart, breakEnd, breakDuration]);

  useEffect(() => {
    if (breakStart) {
      if (breakStart && !breakEnd) {
        setIsFormValid(false)
      } else {
        setIsFormValid(true)
      }
    }
  }, [breakStart, breakEnd])

  return (
    <div data-testid="MealEntry" className={styles.MealEntry}>
      <Row className={styles.MealHeader}>
        <Col>
          <h4>Meal Period {entryNumber}</h4>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={3} lg={{ span: 3 }} >
          <TextInput
            title="Start"
            id={`startTime${entryNumber}`}
            onValueChange={setBreakStart}
            placeholder={'HH:MM'}
            type='time'
            isDisabled={isDisabled}
            values={breakStart}
            name={`${entryNumber}StartTime`}
            required={breakEnd ? true : false}
            onClick={(name) => {
              checkWorkedDate()
              setSelectedFieldName(name)
            }}
            isDateWorkedEmpty={isDateWorkedEmpty && selectedFieldName === `${entryNumber}StartTime`}
            isFieldInvalid={(submitEntry && breakEnd && !breakStart) ? true : false}
          />
          {isDateWorkedEmpty && selectedFieldName === `${entryNumber}StartTime` &&
            <p style={{ color: 'red', fontSize: 12 }}>Please define the date worked</p>}
          {(submitEntry && breakEnd && !breakStart) &&
            <p style={{ color: 'red', fontSize: 12 }}>Please select start time</p>}
        </Col>
        <Col xs={12} md={3} lg={{ span: 3 }} >
          <TextInput
            title="End"
            onClick={(name) => {
              checkWorkedDate()
              setSelectedFieldName(name)
            }}
            id={`endTime${entryNumber}`}
            onValueChange={setBreakEnd}
            placeholder={'HH:MM'}
            type='time'
            isDisabled={(isDisabled || !breakStart) && !isEditEntry}
            required={breakStart ? true : false}
            fieldValidation={breakStart ? "required" : ''}
            name={`${entryNumber}EndTime`}
            values={breakEnd}
            isDateWorkedEmpty={isDateWorkedEmpty && selectedFieldName === `${entryNumber}EndTime`}
            isFieldInvalid={(submitEntry && breakStart && !breakEnd) ? true : false}
          />
          {isDateWorkedEmpty && selectedFieldName === `${entryNumber}EndTime` &&
            <p style={{ color: 'red', fontSize: 12 }}>Please define the date worked</p>}
          {(submitEntry && breakStart && !breakEnd) && <p style={{ color: 'red', fontSize: 12 }}>Please select end time</p>}
        </Col>
      </Row>
    </div>
  );
};

export default MealEntry;